import type { RiskAuditByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetRiskAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetRiskAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetRiskAuditByIdArgs = {
  id: string;
};

export const useGetRiskAuditById = createQueryHook<
  UseGetRiskAuditByIdArgs,
  RiskAuditByIdResponseRow[],
  GetRiskAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.audit.getRiskAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ risk_audit: data }),
  graphqlDocument: GetRiskAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
